import { buildProperty, buildCollection } from "@firecms/core";
import enumLocales from "./locales.enum";

const LocaleSchema = buildCollection({
  id: "locales",
  path: "locales",
  customId: enumLocales,
  name: "Locale",
  hideFromNavigation: false,
  properties: {
    content: buildProperty({
      name: "Content",
      description:
        "Example of a complex array with multiple properties as children",
      validation: { required: true },
      dataType: "array",
      columnWidth: 400,
      oneOf: {
        properties: {
          images: {
            name: "Images",
            dataType: "array",
            of: {
              dataType: "string",
              storageMeta: {
                mediaType: "image",
                storagePath: "images",
                acceptedFiles: ["image/*"],
                metadata: {
                  cacheControl: "max-age=1000000",
                },
              },
            },
            description:
              "This fields allows uploading multiple images at once and reordering",
          },
          text: {
            dataType: "string",
            name: "Text",
            columnWidth: 400,
            markdown: true,
          },
          small_text: {
            dataType: "string",
            name: "Small text",
            columnWidth: 400,
            markdown: true,
          },
        },
      },
    }),
  },
});

export default LocaleSchema;
